import { SessionAssetList } from '../SessionAssetList';
import MobileAssetGroupEmerg from '../cards/MobileAssetGroupEmerg';
import AddAssetButton from '../../../../components/ui/AddAssetButton';
import { deriveMobileGroupCardFields } from '../cards/mobileGroupCardData';

/**
 * Per-group drill-down screen — asset cards for a single board/group.
 *
 * Reuses SessionAssetList (which dispatches to the right card type via AssetCard)
 * so DB → MobileTestCardDistributionBoard, RCD → MobileTestCardRcd,
 * standard → DefaultTestCard, exit/emergency → DefaultTestCard.
 *
 * Exit/emergency groups get a MobileAssetGroupEmerg timer block above the cards.
 * Footer: AddAssetButton scoped to this group.
 */
export default function MobileGroupDrillDown({
  groupName,
  items,
  sessionAssetType,
  sessionTestType,
  sessionTestDate,
  isExitEmergency,
  isSyncing,
  results,
  rcdInputs,
  setRcdInput,
  dualCheckInputs,
  setDualCheckInput,
  handleInlineRcdSave,
  handleQuickPass,
  openEditModal,
  openFailEditModal,
  // Exit/emergency timer
  timerStatus = 'idle',
  timerRemainingMs = 0,
  onTimerStart,
  onTimerRequestReset,
  // Add asset
  onAddAsset,
}) {
  const { testedCount, totalCount } = deriveMobileGroupCardFields(
    groupName, items, sessionAssetType, results
  );
  const remaining = totalCount - testedCount;

  return (
    <div className="mobile-group-drilldown">
      {isExitEmergency && (
        <div className="mobile-group-drilldown__timer">
          <MobileAssetGroupEmerg
            groupCode={groupName}
            unitCount={totalCount}
            testedCount={testedCount}
            totalCount={totalCount}
            status={timerStatus}
            remainingMs={timerRemainingMs}
            expanded={false}
            onToggle={() => {}}
            onStart={onTimerStart}
            onRequestReset={onTimerRequestReset}
          />
        </div>
      )}

      <div className="mobile-group-drilldown__countline">
        <span className="mobile-group-drilldown__count-left">
          {testedCount} OF {totalCount} TESTED
        </span>
        <span
          className={`mobile-group-drilldown__count-right${
            remaining <= 0 ? ' mobile-group-drilldown__count-right--complete' : ''
          }`}
        >
          {remaining > 0 ? `${remaining} REMAINING` : 'COMPLETE'}
        </span>
      </div>

      <SessionAssetList
        items={items}
        groupName={groupName}
        groupLabel={groupName}
        results={results}
        sessionAssetType={sessionAssetType}
        sessionTestType={sessionTestType}
        sessionTestDate={sessionTestDate}
        isExitEmergency={isExitEmergency}
        isSyncing={isSyncing}
        rcdInputs={rcdInputs}
        setRcdInput={setRcdInput}
        dualCheckInputs={dualCheckInputs}
        setDualCheckInput={setDualCheckInput}
        handleInlineRcdSave={handleInlineRcdSave}
        handleQuickPass={handleQuickPass}
        openEditModal={openEditModal}
        openFailEditModal={openFailEditModal}
      />

      <div className="mobile-group-drilldown__footer">
        <AddAssetButton groupLabel={groupName} onClick={onAddAsset} />
      </div>
    </div>
  );
}
